/**
 * Build an anchor element (DOMString) for legal blocks
 *
 * @param href Redirect link path
 * @param text Text to be display
 * @param id HTML id of the anchor tag
 */
export const generateLink = (
    href: string,
    text: string,
    id?: string,
    noStyle?: boolean,
): string => {
    const newWindowValue = $localize`:@@hermes.footer.social.new-window:(new window)`;
    if (id) {
        return `<a ${
            noStyle ? "" : 'style="text-decoration: underline;" '
        }data-testid="${id}" target="_blank" rel="noopener noreferrer" title="${text} ${newWindowValue}" href="${href}" id="${id}">${text}</a>`;
    }
    return `<a ${
        noStyle ? "" : 'style="text-decoration: underline;" '
    }target="_blank" rel="noopener noreferrer" title="${text} ${newWindowValue}" href="${href}">${text}</a>`;
};
